import { BusinessError } from '@marketing-milk/interfaces'
import { Button, Grid } from '@material-ui/core'
import BuildIcon from '@material-ui/icons/Build'
import React from 'react'

export interface ErrorCenterProps {
  errors: BusinessError[]
  onResolve: (error: BusinessError) => {}
}

const businessErrorRecord: Record<BusinessError, string> = {
  [BusinessError.ad_account_access_error]:
    "Facebook rejected our requests for this ad account. It may be the authorizer — check that this user is added to the Facebook Ad Account as a connected user with Manage ad accounts, Manage campaigns (ads), and View performance access on Facebook's Business Manager, update the Authorizer on Marketing Milk, and have them re-log in to Facebook. It may instead be the ad account itself, which Facebook's account settings screen will say. After resolving it, you should be able to clear the error.",
  [BusinessError.page_access_error]:
    "The Page Authorizer is missing permissions / has an expired token. Ensure that this user is added to the Facebook Page as a connected user with Leads, Content, Ads, and Insights access on Facebook's Business Manager, then update the Authorizer on Marketing Milk. If that does not work, be sure to have the authorizer re-log in to Facebook. After these steps, you should be able to clear the error.",
  [BusinessError.offline_upload_error]:
    'Uploads to Facebook have failed due to improper configuration. Please make sure you have an Dataset ID configured with the Conversions API. If you are still using an Offline Event Set ID your business will fail to upload to facebook.',
  [BusinessError.google_ads_access_error]:
    "Google rejected our requests for this Google Ads account. The authorizer's Google account is no longer connected — have them reconnect their Google account under User Preferences, or update the Google Authorizer on Marketing Milk to a user who has. After resolving it, you should be able to clear the error.",
}

const businessErrorHeaderRecord: Record<BusinessError, string> = {
  [BusinessError.ad_account_access_error]: 'Ad Account Access Error',
  [BusinessError.page_access_error]: 'Page Access Error',
  [BusinessError.offline_upload_error]: 'Offline Upload Error',
  [BusinessError.google_ads_access_error]: 'Google Ads Access Error',
}

export const ErrorCenter = ({ errors, onResolve }: ErrorCenterProps) => {
  return (
    <div className="alert alert-danger" role="alert">
      <div className="alert-text">
        <h2 className="alert-heading">Business Error Center</h2>
        <p>
          We have detected some issues with this business. It is likely due to your Facebook or
          Google Ads configuration. Please review the following issues and follow the instructions.
          You can clean the errors after following the suggested steps.
        </p>
        <p>
          <strong>Note: </strong>you must save changes to the business before you can clear the
          errors
        </p>
        <hr />
        <ul>
          {errors.map((error, i) => (
            <div className="py-2">
              <Grid container spacing={4}>
                <Grid item xs={10}>
                  <h3>{businessErrorHeaderRecord[error]}</h3>
                  <span>{businessErrorRecord[error]}</span>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    key={`resolve-btn-${i}`}
                    variant="contained"
                    color="default"
                    onClick={() => onResolve(error)}
                  >
                    <BuildIcon className="mr-2" /> Clear
                  </Button>
                </Grid>
              </Grid>
            </div>
          ))}
        </ul>
      </div>
    </div>
  )
}
